import { render, staticRenderFns } from "./orderReturnDetail.vue?vue&type=template&id=967eed82&scoped=true&"
import script from "./orderReturnDetail.vue?vue&type=script&lang=js&"
export * from "./orderReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderReturnDetail.vue?vue&type=style&index=0&id=967eed82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967eed82",
  null
  
)

export default component.exports